import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShaderEffect: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shader-effect, material"><path d="M19.9307 4.12891C20.5919 4.80502 21 5.72962 21 6.75V17.25C21 19.3211 19.3211 21 17.25 21H6.75C5.72962 21 4.80502 20.5919 4.12891 19.9307L19.9307 4.12891Z" fill="currentColor"/><path d="M17.25 3C17.7497 3 18.2261 3.09895 18.6621 3.27637L3.27637 18.6621C3.09895 18.2261 3 17.7497 3 17.25V13.0605L13.0605 3H17.25Z" fill="currentColor"/><path d="M3 10.9395V6.75C3 4.67893 4.67893 3 6.75 3H10.9395L3 10.9395Z" fill="currentColor"/></CentralIconBase>;
};

export default IconShaderEffect;
